<template>
    <div id="app">
        <v-app id="inspire">    
            <v-flex><br><br><br>
                <v-container>
                    <v-stepper v-model="stepper">
                        <v-stepper-header class="blue-grey darken-3">
                            <v-stepper-step color="green darken-2" :complete="stepper > 1" step="1" >
                                <span class="white--text">{{ branch }}</span>
                            </v-stepper-step>

                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 2" step="2">
                                <span class="white--text">Select Motorcycle</span>
                            </v-stepper-step>
                    
                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 3" step="3" >
                                <span class="white--text">Services</span>
                            </v-stepper-step>
                    
                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 4" step="4" >
                                <span class="white--text">Schedule</span>
                            </v-stepper-step>

                            <v-divider></v-divider>
                    
                            <v-stepper-step color="green darken-2" :complete="stepper > 5" step="5" >
                                <span class="white--text">Review Appointment</span>
                            </v-stepper-step>
                        </v-stepper-header>
                    
                        <v-stepper-items class="grey lighten-5">
                            <v-stepper-content step="2">
                                <v-layout wrap>
                                    <v-container>
                                        <v-flex xs12>
                                            <div v-if="user">
                                                <v-flex xs12 class="pl-3 hidden-md-and-up"> 
                                                    <v-btn v-if="user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                                    <v-btn v-else right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                                                </v-flex>

                                                <v-flex xs12 class="pl-3 hidden-sm-and-down"> 
                                                    <v-btn v-if="user.mobileNumber == ''"  right color="red accent-4" large outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                                    <v-btn v-else right color="red accent-4" large outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-select label="Select your motorcycle" required v-model="mcUnit" prepend-icon="motorcycle" :items="mcOwned"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                                    <v-text-field v-model="oldOdo" label="Last Mileage(km)" required  prepend-icon="timer" readonly></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                                    <v-text-field v-model="odometer" label="Current Mileage(km)" required mask="#######" placeholder="Optional" prepend-icon="timer"></v-text-field>
                                                </v-flex>
                                            </div>

                                            <div v-else>
                                                <v-flex xs12>
                                                    <v-select label="Motorcycle Classification" required :items="masterClassifications" v-model="masterClassification"
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-select label="Brand" required :items="masterBrands" v-model="masterBrand" 
                                                    ></v-select>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-combobox label="Model" required :items="masterModels" v-model="masterModel"
                                                    ></v-combobox>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field v-model="odometer" mask="#######" label="Mileage(km)" placeholder="Optional"></v-text-field>
                                                </v-flex>
                                            </div>

                                            <v-container text-xs-center>
                                                <v-layout class="justify-center">
                                                    <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="goToPage('branch-locator')">Back</v-btn>
                                                    <v-btn v-if="user" color="blue darken-4" class="white--text" @click="mcValidation()"> Next </v-btn>
                                                    <v-btn v-else color="blue darken-4" class="white--text" @click="masterValidation()"> Next </v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-container>
                                </v-layout>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.
                                </v-card-title>

                            </v-stepper-content>
                    
                            <v-stepper-content step="3">
                                <!-- LARGE DEVICE -->
                                <v-layout wrap class="hidden-sm-and-down">
                                    <v-flex xs6>
                                        <v-card-title class="justify-center title font-weight-black pb-0 pt-4">SERVICE MENU
                                        </v-card-title>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3">
                                                    <v-card-title class="text-uppercase justify-center subheading font-weight-bold pb-0">{{category}}</v-card-title>

                                                    <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                        <v-checkbox class="pa-0" type="checkbox" :label="service.serviceName" v-model="selected.service" :value="service"/>
                                                        <v-card-title class="caption font-weight-regular pt-0">{{service.description}}
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    
                                    <v-flex xs6 class ="pt-3">
                                        <v-container grid-list-sm fluid>
                                            <v-layout v-for="(list,index) in otherServices" :key="index">
                                                <v-flex xs12>
                                                    <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required
                                                    append-outer-icon="cancel" @click:append-outer="removeOtherService(index)"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex xs12 class="pl-0">
                                                <v-btn outline dark color="red accent-4" @click="addOtherServices()">Add Other Services</v-btn>
                                            </v-flex>
                                        </v-container>

                                        <v-container text-xs-center>
                                            <v-layout class="justify-center">
                                                <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="stepper=2">Back</v-btn>
                                                    <v-btn color="blue darken-4" class="white--text" @click="(serviceValidation(),setServices(),chargeEstimate())"> Next </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-layout>

                                <!-- SMALL DEVICE -->
                                <v-layout wrap class="hidden-md-and-up">
                                    <v-flex xs12>
                                        <v-card-title class="justify-center title font-weight-bold pb-0 pt-4">SERVICE MENU
                                        </v-card-title>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3">
                                                    <v-card-title class="text-uppercase justify-center subheading font-weight-bold pb-0">{{category}}</v-card-title>

                                                    <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                        <v-checkbox class="pa-0" type="checkbox" :label="service.serviceName" v-model="selected.service" :value="service"/>
                                                        <v-card-title class="caption font-weight-regular pt-0">{{service.description}}
                                                        </v-card-title>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                    
                                    <v-flex xs12 class ="pt-3">
                                        <v-container grid-list-sm fluid>
                                            <v-layout v-for="(list,index) in otherServices" :key="index">
                                                <v-flex xs12>
                                                    <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required
                                                    append-outer-icon="cancel" @click:append-outer="removeOtherService(index)"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex xs12 class="pl-0">
                                                <v-btn outline dark color="red accent-4" @click="addOtherServices()">Add Other Services</v-btn>
                                            </v-flex>
                                        </v-container>

                                        <v-container text-xs-center>
                                            <v-layout class="justify-center">
                                                <v-flex xs12>
                                                    <v-btn color="grey darken-1" class="white--text" @click="stepper=2">Back</v-btn>
                                                    <v-btn color="blue darken-4" class="white--text" @click="(serviceValidation(),setServices(),chargeEstimate())"> Next </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-layout>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.
                                </v-card-title>
                            </v-stepper-content>

                            <v-stepper-content step="4">
                                <v-container>
                                    <!-- LARGE DEVICES  -->
                                    <v-layout class="hidden-sm-and-down">
                                        <v-flex xs7>
                                            <div>
                                                <v-date-picker v-model="calendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" event-color="red">
                                                </v-date-picker>
                                            </div><br>
                                            
                                            <v-layout justify-center>
                                                <v-btn color="grey darken-1" class="white--text" @click="stepper=3">Back</v-btn>
                                                <v-btn color="blue darken-4" class="white--text" @click="(scheduleValidation(),timeUpdate())"> Next </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs5>
                                            <v-container grid-list-md text-xs-center>
                                                <v-layout row wrap v-if="!arrayEvents.includes(calendar)">
                                                    <v-flex xs12>
                                                        <v-select v-model="mechanic" :items="mechanics" label="Select Mechanic*" hide-details></v-select>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-2">PM 
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>

                                    <!-- SMALL DEVICES  -->
                                    <v-layout row wrap class="hidden-md-and-up">
                                        <v-flex xs12>
                                            <div>
                                                <v-date-picker v-model="calendar" header-color="red" full-width class="mt-3" :min="date" :max="maximumDate" :allowed-dates="allowedDates" :events="arrayEvents" event-color="red">
                                                </v-date-picker>
                                            </div><br>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-container grid-list-md text-xs-center>
                                                <v-layout row wrap v-if="!arrayEvents.includes(calendar)">
                                                    <v-flex xs12>
                                                        <v-select v-model="mechanic" :items="mechanics" label="Select Mechanic*" hide-details></v-select>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-0">AM
                                                        </v-card-title>

                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am') && new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('am')" :label="list" :value="list" class="subheading font-weight-medium pb-2"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-card-title height=10 class="headline font-weight-medium pb-2">PM 
                                                        </v-card-title>
                                                        <v-radio-group v-if="calendar == timepast.split(', ')[0].trim()" v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm') &&  new Date(`${timepast.split(', ')[0].trim()} ${list}`).getTime() >= new Date(timepast.replace(',', '')).getTime()" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>

                                                        <v-radio-group v-else v-model="schedtime" row>
                                                            <v-radio v-for="list in times" :key="list" v-if="list.includes('pm')" :label="list" :value="list" class="subheading font-weight-medium pb-1"></v-radio>
                                                        </v-radio-group>
                                                    </v-flex>

                                                </v-layout>
                                            </v-container>
                                        </v-flex>

                                        <v-layout justify-center>
                                            <v-btn color="grey darken-1" class="white--text" @click="stepper=3">Back</v-btn>
                                            <v-btn color="blue darken-4" class="white--text" @click="(scheduleValidation(),timeUpdate())"> Next </v-btn>
                                        </v-layout>
                                    </v-layout>
                                </v-container>

                                <v-card-title height=10 class="caption font-weight-regular justify-center">Note: Please arrive at least 15 minutes before the appointment schedule to avoid booking cancellation.
                                </v-card-title>
                            </v-stepper-content>

                            <v-stepper-content step="5">
                                <v-flex xs12 md12 lg12>
                                    <v-card-title class="justify-center display-1 font-weight-black">APPOINTMENT SUMMARY
                                    </v-card-title>
                                </v-flex>

                                <v-container>
                                    <v-layout wrap>
                                        <v-flex xs12 md6 lg6 v-if="Scheduler.appointment">
                                            <v-card-title class="subtitle-2 font-weight-black pb-2"> 
                                                Work Requested
                                            </v-card-title>
                                            
                                            <v-card-title v-for="card in Scheduler.appointment.initialService" :key="card.id" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.displayName}}
                                            </v-card-title>

                                            <v-card-title v-for="(card,index) in Scheduler.appointment.otherService" :key="index" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.service}}
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs12 md6 lg6 v-else>
                                            <v-card-title class="subtitle-2 font-weight-black pb-2"> 
                                                Work Requested
                                            </v-card-title>
                                            
                                            <v-card-title v-for="card in initialService" :key="card.id" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.displayName}}
                                            </v-card-title>

                                            <v-card-title v-for="(card,index) in otherServices" :key="index" class="title font-weight-black pb-0 pt-0"> 
                                                {{card.service}}
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs12 md6 lg6 v-if="Scheduler.appointment">
                                            <v-card-title v-if="user" class="subtitle-2 font-weight-black pb-0"> 
                                                {{user.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="user" class="subtitle-2 font-weight-bold pb-0 pt-0"> 
                                                {{user.email}} | +63{{user.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.branch}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.formatedDate}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{Scheduler.appointment.appointmentTime}}
                                            </v-card-title><br>

                                            <v-divider></v-divider>
                                        </v-flex>
                                        
                                        <v-flex xs12 md6 lg6 v-else>
                                            <v-card-title v-if="user" class="subtitle-2 font-weight-black pb-0"> 
                                                {{user.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="user" class="subtitle-2 font-weight-bold pb-0 pt-0"> 
                                                {{user.email}} | +63{{user.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{branch}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{computedDateFormattedMomentjs}}
                                            </v-card-title>

                                            <v-card-title class="headline font-weight-black pt-0 pb-0"> 
                                                {{schedtime}}
                                            </v-card-title><br>

                                            <v-divider></v-divider>
                                        </v-flex>
                                        
                                        <v-layout wrap class="justify-center" v-if="user && !Scheduler.appointment">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn v-if="user.mobileNumber" dark color="blue darken-4" @click="(generateId())"> Save </v-btn>
                                        </v-layout>

                                        <v-layout wrap class="justify-center" v-if="user && Scheduler.appointment">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn v-if="user.mobileNumber && Scheduler.appointment.motorcycleDetails.email != ''" dark color="blue darken-4" @click="(generateId())"> Save </v-btn>
                                            <v-btn v-else-if="!user.mobileNumber" dark color="blue darken-4" @click="openProfileDialog()"> Update Profile </v-btn>
                                            <v-btn v-else-if="Scheduler.appointment.motorcycleDetails.email == '' && user.mobileNumber" dark color="blue darken-4" @click="mcSelectionDialog=true" >Verify</v-btn>
                                        </v-layout>
                                        

                                        <v-layout wrap class="justify-center" v-else-if="!user">
                                            <v-btn dark color="grey darken-1" @click="cancelDialog=true">Cancel</v-btn>
                                            <v-btn dark color="blue darken-4" @click="storeDetails()"> Confirm </v-btn>
                                        </v-layout>
                                    </v-layout><br>
                                </v-container>

                                <v-flex xs12>
                                    <v-card-title height=10 class="caption font-weight-regular">Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic. Once you click Save, your appointment is still pending for Branch Approval. You will receive notification once approved. Please arrive at least 15 minutes before the appointment schedule to avoid booking cancellation.
                                    </v-card-title>
                                </v-flex>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
            </v-flex>

            <v-snackbar v-model="showAlert" bottom right :color="alertColor">{{alertMessage}}
                <v-btn small dark flat @click="showAlert = false">Close</v-btn>
            </v-snackbar>

            <v-layout row justify-center >
                <v-dialog  v-model="dialog" persistent width="300">
                    <v-card color="blue-grey darken-3">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true"
                                :size="70"
                                :width="5"
                                color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-dialog  v-model="nsDialog" persistent width="300">
                    <v-card color="blue-grey darken-3">
                        <v-card-text class="subheading white--text"> {{nsProgressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true"
                                :size="70"
                                :width="5"
                                color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-dialog v-model="updateInfoDialog" persistent max-width="800px">
                <profile-component></profile-component>
            </v-dialog>

            <v-dialog v-model="cancelDialog" max-width="500px">
                <v-card>
                    <v-card-title class="title font-weight-regular">
                        Alert
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-title class="subheading font-weight-regular justify-center">
                        Are you sure you want to cancel application ? 
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                        <v-btn color="grey darken-1" dark @click="cancelDialog=false">NO</v-btn>
                        <v-btn color="blue darken-4" dark @click="cancelAppointment()">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="mcSelectionDialog" persistent max-width="600px">
                <v-card>
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12 class="pl-3 hidden-md-and-up"> 
                                <v-btn v-if="user && user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                <v-btn v-else-if="user && user.mobileNumber != ''" right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                            </v-flex>

                            <v-flex xs12 class="pl-3 hidden-sm-and-down"> 
                                <v-btn v-if="user && user.mobileNumber == ''"  right color="red accent-4" small outline @click="openProfileDialog()">Add Motorcycle</v-btn>

                                <v-btn v-else-if="user && user.mobileNumber != ''" right color="red accent-4" small outline @click="openMotorcycleDialog(),odometer=''">Add Motorcycle</v-btn>
                            </v-flex>

                            <v-flex xs12>
                                <v-select label="Select your motorcycle" required v-model="mcUnit" prepend-icon="motorcycle" :items="mcOwned"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                <v-text-field v-model="oldOdo" label="Last Mileage(km)" required  prepend-icon="timer" readonly></v-text-field>
                            </v-flex>

                            <v-flex xs12 v-if="mcUnit != '' && mcUnit != null">
                                <v-text-field v-model="odometer" mask="#######" label="Current Mileage(km)" required  prepend-icon="timer"></v-text-field>
                            </v-flex>

                            <v-container text-xs-center>
                                <v-layout class="justify-center">
                                    <v-flex xs12>
                                    <v-btn color="grey darken-1" class="white--text" @click="mcSelectionDialog=false">Back</v-btn>
                                    <v-btn color="blue darken-4" class="white--text" @click="mcVerified()"> Next </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="newMcProfileDialog" persistent max-width="600px">
                <motorcycle-component></motorcycle-component>
                <!-- <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="70">
                        <v-container>
                            <v-layout>
                            <h4 class="subheading font-weight-medium">NEW MOTORCYCLE</h4>
                            </v-layout>
                        </v-container>
                    </v-parallax> 

                    <v-card-text>
                        <v-container grid-list-md class="pb-0 pt-0">
                            <v-layout wrap>
                                <v-flex xs12 sm12 md12>
                                    <v-select class="pt-0" v-model="dealer" label="Dealer/Store*" required :items="dealers" hide-details></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select label="Motorcycle Classification" required :items="masterClassifications" v-model="classification"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select label="Brand" required :items="masterBrands" v-model="make" 
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-combobox label="Model" required :items="masterModels" v-model="model"
                                    ></v-combobox>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-menu ref="yearModelMenu" :close-on-content-click="false" v-model="yearModelMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <v-text-field slot="activator" v-model="yearModel" label="Year Model*" readonly hide-details></v-text-field>
                                        <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" v-model="yearModel" @input="save" reactive no-title></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Color*" v-model="mcColor" hide-details
                                    ></v-text-field>
                                </v-flex>
                            
                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Engine Number*" v-model="engineNumber" hide-details
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Chassis Number" v-model="chassisNumber" hide-details
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Plate Number*" v-model="plateNumber" hide-details
                                    ></v-text-field>
                                </v-flex>
                                
                                <v-flex xs12 sm12 md12>
                                    <v-menu v-model="dateOfPurchaseMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="dateOfPurchase" label="Date of Purchase" readonly v-on="on" hide-details></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dateOfPurchase" @input="dateOfPurchaseMenu=false"></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-menu v-model="registrationDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="registrationDate" label="Registration Date" readonly v-on="on" hide-details></v-text-field>
                                        </template>
                                        <v-date-picker v-model="registrationDate" @input="registrationDateMenu=false"></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Current Mileage(km)*" class="pb-2" v-model="odometer" hide-details
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        
                        <v-layout justify-center>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn dark color="red accent-4" @click="newMcProfileDialog=false,odometer=''">Close</v-btn>
                                <v-btn dark color="blue darken-4" @click="saveMcDetails()">Save</v-btn>
                            </v-card-actions>
                        </v-layout>
                    </v-card-text>
                </v-card> -->
            </v-dialog>
        </v-app>
    </div>
</template>

<script>
import loginComponent from './Login.vue'
import profileComponent from './Profile.vue'
import motorcycleComponent from './Motorcycle.vue'
import {db} from '../main'
import { mapGetters, mapState } from "vuex"
import { setTimeout } from 'timers'
import _ from 'lodash'
import moment from 'moment'
export default {
    components: {
        loginComponent,
        profileComponent,
        motorcycleComponent,
    },
    data() {
        return {
            branch: this.$route.params.branch,
            branchCode: this.$route.params.branchCode,
            branchId: this.$route.params.id,
            stepper: this.$route.params.step,
            timeout: 2000,
            allowedDates: null,
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            maximumDate: moment().add(3, 'months').toISOString().substr(0, 10),
            headers: [
                { text: '', align: 'left', sortable: false,  value: '', width: '1%'},
                { text: 'Items for checking', align: 'left', sortable: false,  value: 'name'},
                { sortable: false, align: 'center', text: '', value: ''},
                { sortable: false, align: 'center', text: 'Estimated Price', value: 'price' },
            ],
            services: [],
            estimateCharge: 0,
            chargeHolder: [],
            timeHolder: [],
            estimateTime: 0,
            selected: { service: []},
            cancelDialog: false,
            calendar: moment().utcOffset('+0800').toISOString().substr(0, 10),
            times: [],
            timeDialog: false,
            schedtime: null,
            initialService: [],
            id: 0,
            removed: [],
            dialog: true,
            showServices: false,
            showCoupon: false,
            coupon: "",
            lists: [],
            laps: [],
            timeValidation: [],
            timeValidation2: [],
            timeRemoveHolder: [],
            timesChecker: [],
            showAlert: false,
            alertMessage: "",
            alertColor: "",
            arrayEvents: [],
            odometer: "",
            dateOfPurchase: null,
            dateOfPurchaseMenu: false,
            registrationDate: null,
            registrationDateMenu: false,
            oldOdo: "",
            mcOwned: [],
            mcLists: [],
            mcUnit: "",
            newMcProfileDialog: false,
            mcColor: "",
            dealer: "",
            make: "",
            model: "",
            yearModel: null,
            yearModelMenu: false,
            engineNumber: "",
            chassisNumber: "",
            dealers: [],
            brands: [],
            currentOdo: [],
            branchMechanics: [],
            mechanics: [],
            mechanic: "",  
            progressDialog: false,
            progressMessage: "Checking for Services",
            nsDialog: false,
            nsProgressMessage: "",
            otherServices: [{
                service: "",
                price: 0,
                time: 0,
            }],
            plateNumber: "",
            timeObtain: [],
            transactions: [],
            selectedMc: null,
            bufferTime: 0,
            classifications: [],
            classification: "",
            serviceMenu: [],
            timepast: moment().format('YYYY-MM-DD, hh:mm a'),
            serviceCategory: [
                "Tune Up",
                "Carburator & Fuel Injection System",
                "Top Overhauling",
                "Major Overhauling",
                "Side Overhauling",
                "Oil Seals",
                "Brake System",
                "Steering System",
                "Cables",
                "Drive Chain & V-Belt",
                "Front and Rear Wheel",
                "Electrical Wiring",
                "Other Services"
            ],
            materialMaster: [],
            masterClassifications: [
                'CUB',
                'Automatic',
                'Business',
                'Hi-End',
            ],
            masterClassification: "",
            masterBrands: [],
            masterBrand: "",
            masterModels: [],
            masterModel: "",
            updateInfoDialog: false,
            mcSelectionDialog: false,
            eventTimes: []
        }
    },


    methods : {
        fetchTimeSchedule(){
            let self = this
            let count = 0
            self.timesChecker = []
            db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.timesChecker.push(doc.data().time)
                    count ++

                    if (count === querySnapshot.docs.length) {
                        self.timesChecker.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB);
                        })
                    }
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        async fetchClassification() {
            let self = this
            self.classifications = []
            await db.collection("Settings"+self.$stage).doc("Classification")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.alertColor = "red accent-4"
                        self.alertMessage = "Classification should be set"
                        self.showAlert = true
                    } else {
                        self.classifications.push(doc.data().classification)
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.alertColor = "red accent-4"
                self.alertMessage = "Buffer time should be set"
                self.showAlert = true
            })
        },

        async fetchBufferTime() {
            let self = this
            await db.collection("Settings"+self.$stage).doc("BufferTime")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.bufferTime = 0
                        self.alertColor = "red accent-4"
                        self.alertMessage = "Buffer time should be set"
                        self.showAlert = true
                    } else {
                        self.bufferTime = doc.data().time
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.alertColor = "red accent-4"
                self.alertMessage = "Buffer time should be set"
                self.showAlert = true
            })
        },

        saveMcDetails() {
            let self = this
            let customerFullName = ""
            let customerMobile = ""
            if (self.engineNumber === ""){
                self.alertColor = "red accent-4"
                self.alertMessage = "Engine number should not be blank"
                self.showAlert = true
            } else if (self.plateNumber === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Plate number should not be blank"
                self.showAlert = true
            } else if (self.dealer === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Dealer should not be blank"
                self.showAlert = true
            } else if (self.make === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (self.model === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (self.odometer === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Please input current kilometer mileage"
                self.showAlert = true
            } else if (self.yearModel === "" || self.yearModel === null) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Year model should not be blank"
                self.showAlert = true
            } else if (self.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else if (self.mcColor === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Color should not be blank"
                self.showAlert = true
            } else {
                if (self.user.fullName) {
                    customerFullName = self.user.fullName
                } else {
                    customerFullName = ""
                }

                if (self.user.mobileNumber) {
                    customerMobile = self.user.mobileNumber
                } else {
                    customerMobile = ""
                }
                let timeStampId = new Date().getTime().toString()
                db.collection("McDetails"+self.$stage).doc(timeStampId).set({
                    "owner": customerFullName,
                    "email": self.user.email,
                    "mobile": customerMobile,
                    "classification": self.classification, 
                    "dealer": self.dealer,
                    "make": self.make,
                    "model": self.model,
                    "color": self.mcColor,
                    "yearModel": self.yearModel,
                    "engineNumber": self.engineNumber,
                    "chassisNumber": self.chassisNumber,
                    "plateNumber": self.plateNumber,
                    "odometer": self.odometer,
                    "dateOfPurchase": self.dateOfPurchase,
                    "registrationDate": self.registrationDate,
                    "transactions": self.transactions,
                    "status": "1",
                    "id": timeStampId
                }).then(function() {
                    self.classification = ""
                    self.mcColor = ""
                    self.dealer = ""
                    self.make = ""
                    self.model = ""
                    self.yearModel = ""
                    self.engineNumber = ""
                    self.chassisNumber = ""
                    self.odometer = ""
                    self.plateNumber = ""
                    self.dateOfPurchase = ""
                    self.registrationDate = ""
                    self.transactions = []
                    self.fetchMotorcycleDetails()
                    self.closeMotorcycleDialog()
                    self.alertColor = "green darken-2"
                    self.alertMessage="Successfully added"
                    self.showAlert = true
                })
            } 
        },

        fetchMechanics() {
            let self = this
            let mechanics = []
            let scheduleMechanics = []
            db.collection("Mechanics"+self.$stage).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    if(doc.data().status === "Active") {
                        mechanics.push(doc.data())
                    }
                })
            }).then(function(){
                if (mechanics) {
                    mechanics.forEach(function(res) {
                        if(res.branch === self.branch) {
                            self.branchMechanics.push(res)
                        }
                    })
                }
            }).then(function() {
                if (self.branchMechanics) {
                    self.branchMechanics.forEach(function(res) {
                        if (res.tag === true) {
                            scheduleMechanics.push(res)
                        }
                    })
                }
            }).then(function() {
                let countMechanic = 0
                if (scheduleMechanics) {
                    scheduleMechanics.forEach(function(res) {
                        self.mechanics.push(res.name)
                        countMechanic ++
                    })
                    if (countMechanic === scheduleMechanics.length) {
                        self.checkMechanics("")
                    }
                }
            }).then(function(){
                if (self.mechanics.length === 1) {
                    self.mechanic = self.mechanics[0]
                }
            })
        },

        chargeEstimate() {
            let self = this
            self.chargeHolder = []
            self.timeHolder = []
            self.initialService = []

            if (self.selectedMc.classification) {
                self.selected.service.forEach(function (result) {
                    result.classifications.forEach(function(data){
                        if (data.class === self.selectedMc.classification) {
                            self.timeHolder.push(Number(data.time))
                            self.initialService.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                        }
                    })
                })

                self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b }, 0))
                self.estimateCharge =  (self.chargeHolder.reduce(function(a, b) { return a + b }, 0))
                let nf = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'Php',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
                nf.format(self.estimateCharge)
                self.estimateCharge = nf.format(self.estimateCharge)
            }
        },

        timeUpdate() {
            let self = this
            self.removed = []
            let index = []
            let index2 = []
            
            if (self.timeValidation.appointmentTime != "" && self.timeValidation.appointmentTime != null) { 
                index = self.times.indexOf(self.timeValidation.appointmentTime)
                self.removed = self.times.splice(index, self.timeValidation.blockTime)
                console.log(index)
            }

            if (self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null) { 
                index2 = self.times.indexOf(self.timeValidation2.appointmentTime)
                self.removed = self.times.splice(index2, self.timeValidation2.blockTime)
                console.log(index2)
                console.log(self.removed)
            }
        },

        setServiceAppointment(){
            let self = this
            self.timeObtain = []
            db.collection("ServiceBooking"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("appointmentDate","==",self.calendar)
                .where("status","==","Waiting")
                .where("mechanic","==",self.mechanic)
                .get().then(function(querySnapshot) {
                    if (querySnapshot.docs.length > 0) {
                        querySnapshot.forEach(function(res) {
                            res.data().timeHold.forEach(function(data) {
                                self.timeObtain.push(data)
                            })
                        })
                    }
                }).then(function() {
                    if (self.timeObtain.includes(self.schedtime)) {
                        self.dialog=false
                        self.showAlert = true
                        self.alertColor = "red accent-4"
                        self.alertMessage="Time already obtain just now. Please select a new time."
                        setTimeout(() => {
                            self.reload()
                        }, 1000)
                    } else {
                        let payload = null
                        if (self.Scheduler.appointment) {
                            payload = {
                                "motorcycleDetails": self.Scheduler.appointment.motorcycleDetails,
                                "userDetails": self.user,
                                "transactionId": self.id.toString(),
                                "appointmentDate": self.Scheduler.appointment.appointmentDate,
                                "appointmentTime": self.Scheduler.appointment.appointmentTime,
                                "branch": self.branch,
                                "branchCode": self.branchCode,
                                "branchId": self.branchId,
                                "initialService": self.Scheduler.appointment.initialService,
                                "otherService": self.Scheduler.appointment.otherService,
                                "estimateCharge": 0,
                                "status": "ForApproval",
                                "estimateTime": self.Scheduler.appointment.estimateTime,
                                "formatedDate": self.Scheduler.appointment.formatedDate,
                                "timeHold": self.Scheduler.appointment.timeHold,
                                "tag": "No Show",
                                "coupon": "",
                                "fee": 0,
                                "customerType": "Self-Service",
                                "lastOdo": "",
                                "odometer": self.Scheduler.appointment.motorcycleDetails.odometer,
                                "mechanic": self.Scheduler.appointment.mechanic,
                                "serving": "0",
                                "remarks": "",
                                "jobType": [],
                                "dateCreated": moment().format('MMMM Do YYYY, h:mm:ss a'),
                                "dateModified": "",
                                "dateApproval": "",
                                "timein": "",
                                "timeout": ""
                            }
                        } else {
                            payload = {
                                "motorcycleDetails": self.selectedMc,
                                "userDetails": self.user,
                                "transactionId": self.id.toString(),
                                "appointmentDate": self.calendar,
                                "appointmentTime": self.schedtime,
                                "branch": self.branch,
                                "branchCode": self.branchCode,
                                "branchId": self.branchId,
                                "initialService": self.initialService,
                                "otherService": self.otherServices,
                                "estimateCharge": self.estimateCharge,
                                "status": "ForApproval",
                                "estimateTime": self.estimateTime,
                                "formatedDate": self.computedDateFormattedMomentjs,
                                "timeHold": self.removed,
                                "tag": "No Show",
                                "coupon": self.coupon,
                                "fee": 0,
                                "customerType": "Self-Service",
                                "lastOdo": self.oldOdo,
                                "odometer": self.odometer,
                                "mechanic": self.mechanic,
                                "serving": "0",
                                "remarks": "",
                                "jobType": [],
                                "dateCreated": moment().format('MMMM Do YYYY, h:mm:ss a'),
                                "dateModified": "",
                                "dateApproval": "",
                                "timein": "",
                                "timeout": ""
                            }
                        }
                        db.collection("ServiceBooking"+self.$stage).doc(self.id.toString()).set(payload)
                        .then(function(doc) {
                            self.notifications()
                            self.alertColor = "green darken-2"
                            self.alertMessage = "Appointment saved"
                            self.showAlert = true
                            self.dialog=false
                            setTimeout(() => {
                                localStorage.removeItem("redirect")
                                self.$store.dispatch("setAppointment", null)
                                self.goToPage("transactions")
                            }, 2000)
                        })   
                    }
                })

        },

        generateId() {
            let self = this
            let list = []
            let splitSeries = null
            let splitYear = null
            let yearSeries = moment().year()
            let strId = "SS-"
            let pad = "00000"
            let getIndex = null
            let str = null
            let ctrlSeries = null
            self.dialog=true
            self.progressMessage="Saving Appointment..."
            
            db.collection("ServiceBooking"+self.$stage).orderBy("transactionId")
            .get().then(function(snapshot) {
                snapshot.forEach(function(doc) {
                    list.push(doc.id)
                })

                if(list.length < 1) {
                    self.id =  strId + yearSeries + "-" + "00001"
                } else {
                    list.sort(function(a, b){return a-b})
                    splitYear = _.last(list).split("-")[1]

                    if(yearSeries == splitYear) {
                        if(list.length > 0) {
                            getIndex = _.last(list).split("-")[2]
                        } else {
                            getIndex = (Number(list.length - 1) + 1)
                        }
                        str = "" + (Number(getIndex) + 1)
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                        
                    } else {
                        str = "" + 1
                        ctrlSeries = pad.substring(0, pad.length - str.length) + str
                        self.id = strId + yearSeries + "-" + ctrlSeries
                    }
                }
                self.setServiceAppointment()   
            })
        },

        goToPage(page) {
            this.$router.push("/"+page)
        },

        mcValidation() {
            let self = this

            if(self.mcUnit === null || self.mcUnit === "") {
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Please select motorcycle"
            } else {
                self.stepper = 3
            } 
        },

        masterValidation() {
            let self = this

            if((self.masterClassification === "" || self.masterClassification === null) || (self.masterBrand === "" || self.masterBrand === null) || (self.masterModel === "" || self.masterModel === null)) {
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Please input your motorcycle details"
            } else {
                self.stepper = 3
                self.selectedMc = {
                    chassisNumber:"",
                    classification: self.masterClassification,
                    color:"",
                    dateOfPurchase:null,
                    dealer:"",
                    email:"",
                    engineNumber:"",
                    id: "",
                    make: self.masterBrand,
                    mobile:"",
                    model: self.masterModel,
                    odometer:"0",
                    owner:"",
                    plateNumber:"",
                    registrationDate:null,
                    status:"1",
                    transactions:[],
                    yearModel:null
                }
            } 
        },

        serviceValidation() {
            let self = this
            
            if(self.estimateTime < 1) {
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Please select a service"
            } else if (self.estimateTime >= 375) {
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Cannot accomodate too many services."
            } else {
                self.stepper = 4
                self.timepast = moment().format('YYYY-MM-DD, hh:mm a')
            }
        },

        scheduleValidation() {
            let self = this
            if(self.schedtime == null || self.schedtime == "") {
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Please select a time"
            } 
            else {
                self.stepper = 5
                // if (self.user) {
                //     self.openProfileDialog()
                // }
            }
        },

        setServices(){
            let self = this
            if(self.initialService.length > 0){
                self.showServices = true
            }
        },

        reload() {
            window.location.reload()
        },

        notifications() {
            let self = this
            let source = ""
            let emailMessageToBranch = ""
            let branchUsers = []
            let footer = "Note: The services and time are subject to change upon actual diagnosis of the branch service mechanic.".italics()

            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (self.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }
            
            let messagetoBranch = ""
            let smsToBranch = ""
            // let messagetoBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Please go to the" +" service request".link(self.$branchUrl +'/service-approval') + " for your approval."+"\n"+ "Your Approval is required." +"\n\n" + "Thank you."
            // emailMessageToBranch = messagetoBranch.replace(/(\r\n|\n|\r)/gm, "<br>")

            // let smsToBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."

            if (self.Scheduler.appointment) {
                messagetoBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.Scheduler.appointment.formatedDate +" at "+ self.Scheduler.appointment.appointmentTime +" with control number " + self.id +". \n\n" + "Please go to the" +" service request".link(self.$branchUrl +'/service-approval') + " for your approval."+"\n"+ "Your Approval is required." +"\n\n" + "Thank you."
                emailMessageToBranch = messagetoBranch.replace(/(\r\n|\n|\r)/gm, "<br>")

                smsToBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.Scheduler.appointment.formatedDate +" at "+ self.Scheduler.appointment.appointmentTime +" with control number " + self.id +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."
            } else {
                messagetoBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Please go to the" +" service request".link(self.$branchUrl +'/service-approval') + " for your approval."+"\n"+ "Your Approval is required." +"\n\n" + "Thank you."
                emailMessageToBranch = messagetoBranch.replace(/(\r\n|\n|\r)/gm, "<br>")

                smsToBranch = "Dear " + self.branch + ",\n\n"+ self.user.fullName + " has requested an appointment on " + self.computedDateFormattedMomentjs +" at "+ self.schedtime +" with control number " + self.id +". \n\n" + "Click here to see full details of the appointment: " + self.$branchUrl +'/service-approval' +"\n\n"+"Your approval is required."+ "\n\n" + "Thank you."
            }

            db.collection("branchUsers"+self.$stage).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    branchUsers.push(doc.data())
                })
            }).then(function() {
                branchUsers.forEach(function(data) {
                    if(data.branch == self.branch) {
                        let mailerBody = {
                            "receiver" : data.email,
                            "subject" : "Customer Appointment Pending for Approval",
                            "html" : emailMessageToBranch
                        }

                        let smsBody = {
                            "source": source,
                            "destination": self.user.countryCode + data.mobileNumber,
                            "text": smsToBranch,
                            "subaccount": self.$subAccount
                        }

                        self.$axios.post(self.$smsUrl, smsBody).then(function(){}).catch(error => console.log(error))
                        self.$axios.post(self.$mailerUrl, mailerBody).then(function(){}).catch(error => console.log(error))
                    }
                })
            })
        },

        calendarValidation() {
            let self = this
            let getEvents = []
            let getLoad = []
            let totalTimeHold = []
            let pivot = null
            let adminTimeProcess = 0

            db.collection("Events"+self.$stage)
            .where("branchId","==", self.branchId)
            .where("status","==","approved")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                    adminTimeProcess ++
                })

                self.lists.forEach(function(res) {
                    if (res.timeHold.length > 24) {
                        getEvents.push(res.date)
                        self.arrayEvents.push(res.date)
                    }
                })
                if(adminTimeProcess === self.lists.length) {
                    self.lists.forEach(function(result) {
                        if(result.date == self.calendar) {
                            self.eventTimes=result.timeHold
                        }
                    })
                    // try {
                    //     console.log(self.eventTimes, val)
                    //     if( self.calendar != ""){
                    //         self.times = self.times.filter(value => !self.eventTimes.includes(value))
                    //     }
                    // } catch(err) {}
                }
            }).then(function(){
                db.collection("ServiceBooking"+self.$stage).get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        if (doc.data().branch == self.branch && doc.data().status == "Waiting") {
                            getLoad.push(doc.data())
                        }
                    })

                    if (getLoad) {
                        pivot = _(getLoad).groupBy('appointmentDate')
                        .map((item, key) => ({
                            appointmentDate: key,
                            timeHold: _.map(item, 'timeHold'),
                            totalTimeHold: _.sumBy(_.map(item, 'timeHold.length'))
                        })).value()

                        pivot.forEach(function(data) {
                            if(data.totalTimeHold > 24) {
                                getEvents.push(data.appointmentDate)
                                self.arrayEvents.push(data.appointmentDate)
                            }
                        })
                    }

                }).then(function(){
                    self.allowedDates = val =>
                    ![0].includes(new Date(val).getDay())&&!getEvents.includes(new Date(val).toISOString().substr(0, 10),)
                })
            })
        },

        async fetchServiceMaster() {
            let self = this
            let serviceMaster = []

            await db.collection("Services"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    serviceMaster.push(doc.data())
                })
            }).then(function(){
                //console.log(serviceMaster)
            }).catch(function(error){
                console.log(error)
            })
        
        },


        async fetchServiceMenu() {
            let self = this
            let services = []
            self.serviceMenu = []   

            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    }
                })
            }).then(function(){
                self.serviceMenu.sort()
                // self.dialog=false
            }).catch(function(error){
                self.dialog=false
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.alertMessage="Error fetching document"
            })
        },

        fetchMotorcycleDetails() {
            let self = this
            self.mcLists = []
            self.mcOwned = []
            db.collection("McDetails"+self.$stage)
            .where("email","==",self.user.email)
            //.where("owner","==",self.user.fullName)
            .where("status","==","1")
            .get().then(function(querySnapshot){
                if (querySnapshot.docs.length > 0) {
                    querySnapshot.forEach(function(doc){
                        self.mcLists.push(doc.data())
                        self.mcOwned.push(doc.data().model)
                    })
                } 
            }).then(function() {
               // self.mcVerification()
            })
        },

        addOtherServices() {
            let self = this 
            self.otherServices.push({
                service: "",
                price: 0,
                time: 0,
            })
        },

        removeOtherService(index) {
            let self = this 
            self.otherServices.splice(index,1)
        },

        checkMechanics(val) {
            let self = this
            let availableTime = []
            let removedFromDb = []
            let blockTime = 0
            let appointmentTime = ""
            let index = []
            self.schedtime = ""
            self.removed = []
            self.timeValidation = []
            self.timeValidation2 = []
            self.laps = []
            self.dialog=true
            self.progressMessage="Loading..."

            if(val) {
                self.schedtime = null
                db.collection("Mechanics"+self.$stage)
                .where("name","==",val)
                // .where("branchCode","==",self.branchCode)
                .where("branchId","==",self.branchId)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        self.times = doc.data().time
                    })
                }).then(function() {
                    self.times = self.times.filter(value => !self.eventTimes.includes(value))
                    db.collection("ServiceBooking"+self.$stage)
                    .where("branchId","==",self.branchId)
                    .where("appointmentDate","==",self.calendar)
                    .where("status","==","Waiting")
                    .where("mechanic","==",val)
                    .get().then(function(querySnapshot) {
                        if (querySnapshot.docs.length > 0) {
                            querySnapshot.forEach(function(doc) {  
                                self.timeValidation.push({
                                    appointmentTime: doc.data().appointmentTime,
                                    blockTime: doc.data().estimateTime / self.bufferTime
                                })
                            })

                            self.timeValidation.forEach(function(val) {
                                index = self.times.indexOf(val.appointmentTime)
                                removedFromDb = self.times.splice(index, val.blockTime)
                                self.laps.push(removedFromDb)
                            })
                            self.dialog=false
                        } else {
                            self.timeValidation = {
                                appointmentTime: self.schedtime,
                                blockTime: self.estimateTime / self.bufferTime
                            }
                            self.dialog=false
                        }
                    })
                })
            } else {
                self.dialog=false
                self.progressMessage=""
            }
        },

        fetchBrands() {
            let self = this
            self.brands = []
            
            db.collection("Settings"+self.$stage).doc("Brands")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.brands.push(doc.data().brand)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        fetchDealers() {
            let self = this
            self.dealers = []
            
            db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        fetchCategory() {
            let self = this
            self.serviceCategory = []
            
            db.collection("Settings"+self.$stage).doc("Categories")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.serviceCategory.push(doc.data().category)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        cancelAppointment() {
            let self = this
            localStorage.removeItem("redirect")
            self.$store.dispatch("setAppointment", null)
            if (self.$route.params.step == "2") {
                window.location.reload()
            } else {
                self.$router.push(`/service-scheduler/${self.branch}/${self.branchCode}/${self.branchId}/2`)
            }
        },

        async fetchNetsuiteMaterialMaster() {
            let self = this
            self.materialMaster = []
            self.nsDialog = true
            self.nsProgressMessage = "Loading..."
            self.$axios.defaults.headers.common['Authorization']=`NSJ ${self.$consumerKey}&${self.$consumerSecret}`
            self.$axios.defaults.headers.common['ns-token']= self.$tokenId
            self.$axios.defaults.headers.common['ns-token-secret']= self.$tokenSecret
            self.$axios.defaults.headers.common['Content-Type']= self.$contentType
            
            await self.$axios.get(self.$materialMaster).then(function(res){
                res.data.data.forEach(function(result) {
                    let code = {
                        // 'SOLO': 'CUB',
                        // 'SCOOTER': 'Automatic',
                        'BUSINESS': 'Business',
                        // 'BIG BIKE': 'Hi-End',
                        'SOLO/CUB/MOPED': 'CUB',
                        'SCOOTER/AUTOMATIC': 'Automatic',
                        'SPORTS/STREET': 'Hi-End'
                    }

                    for (let key in code) {
                        let re = new RegExp(key, 'gi')
                        result.values["custitem_item_industryclassification"][0]["text"] = result.values["custitem_item_industryclassification"][0]["text"].replace(re, code[key])
                    }

                    result.values.manufacturer = result.values.manufacturer.toLowerCase()
                    
                    self.materialMaster.push({
                        classification: result.values["custitem_item_industryclassification"][0]["text"],
                        brand: result.values.manufacturer.charAt(0).toUpperCase() + result.values.manufacturer.slice(1),
                        model: result.values["custitem_item_description"][0]["text"]
                    })
                })
            }).then(function() {
                self.materialMaster = _.uniqBy(self.materialMaster, 'model');
                self.nsDialog = false
                if (self.user) {
                    self.fetchMotorcycleDetails()
                }
            }).catch(function(error) {
                console.error("Error getting document: ", error)
                self.nsDialog = false
                if (self.user) {
                    self.fetchMotorcycleDetails()
                }
            })
        },

        openProfileDialog() {
            this.$store.dispatch("setProfile", "1")
            this.updateInfoDialog = true
        },

        closeProfileDialog() {
            this.$store.dispatch("setProfile", "0")
            this.updateInfoDialog = false
        },

        storeDetails() {
            let self = this
            self.selectedMc.odometer = self.odometer
            let payload = {
                "motorcycleDetails": self.selectedMc,
                "appointmentDate": self.calendar,
                "appointmentTime": self.schedtime,
                "branch": self.branch,
                "branchCode": self.branchCode,
                "branchId": self.branchId,
                "initialService": self.initialService,
                "otherService": self.otherServices,
                "status": "ForApproval",
                "estimateTime": self.estimateTime,
                "formatedDate": self.computedDateFormattedMomentjs,
                "timeHold": self.removed,
                "customerType": "Self-Service",
                "lastOdo": "0",
                "odometer": self.odometer,
                "mechanic": self.mechanic,
                "status": "active"
            }
            
            self.$store.dispatch("setAppointment", payload ).then(function() {
                localStorage.setItem("redirect", `${window.location.origin}/service-scheduler/${self.branch}/${self.branchCode}/${self.branchId}/5`);
                console.log(self.Scheduler.appointment)
                self.goToPage('login')
            })
        },

        mcVerification() {
            let self = this
            if (self.mcOwned.includes(self.Scheduler.appointment.motorcycleDetails.model)) {
                self.alertColor = "red accent-4"
                self.alertMessage = "Please verify your selected motorcycle to proceed."
                self.showAlert = true
            }
        },

        mcVerified() {
            let self = this
            if (self.Scheduler.appointment.motorcycleDetails.model === self.mcUnit) {
                if (self.Scheduler.appointment) {
                    let payload = {
                        "motorcycleDetails": self.selectedMc,
                        "appointmentDate": self.Scheduler.appointment.appointmentDate,
                        "appointmentTime": self.Scheduler.appointment.appointmentTime,
                        "branch": self.Scheduler.appointment.branch,
                        "branchCode": self.Scheduler.appointment.branchCode,
                        "branchId": self.Scheduler.appointment.branchId,
                        "initialService": self.Scheduler.appointment.initialService,
                        "otherService": self.Scheduler.appointment.otherService,
                        "status": "ForApproval",
                        "estimateTime": self.Scheduler.appointment.estimateTime,
                        "formatedDate": self.Scheduler.appointment.formatedDate,
                        "timeHold": self.Scheduler.appointment.timeHold,
                        "customerType": "Self-Service",
                        "lastOdo": "0",
                        "odometer": self.odometer,
                        "mechanic": self.Scheduler.appointment.mechanic,
                        "status": "active"
                    }
                    self.$store.dispatch("setAppointment", payload)
                    self.mcSelectionDialog = false
                }
            } else {
                self.alertColor = "red accent-4"
                self.alertMessage = "Please select based on your motorcycle information to proceed."
                self.showAlert = true
            }
        },

        openMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", true)
            this.newMcProfileDialog = true
        },
        closeMotorcycleDialog() {
            this.$store.dispatch("setMotorcycle", false)
            this.newMcProfileDialog = false
        },
    },

    mounted() {
        let self = this
        self.closeMotorcycleDialog()
        self.fetchClassification()
        self.fetchBufferTime()
        self.fetchDealers()
        self.fetchBrands()
        self.calendarValidation()
        self.fetchServiceMenu()
        self.fetchServiceMaster()
        self.fetchMechanics()
        self.fetchTimeSchedule()
        self.fetchNetsuiteMaterialMaster()
        if (self.user) {
            self.fetchMotorcycleDetails()
        }

        // if (self.Scheduler.appointment) {
        //     self.mcVerification()
        // }
    },

    computed: {
         computedDateFormattedMomentjs () {
                return this.calendar ? moment(this.calendar).format('dddd, MMMM Do YYYY') : ''
            },
        ...mapGetters(["user","appointment"]),
        ...mapState(["Auth","Scheduler"]),
    },

    watch: {
        masterClassification(val) {
            let self = this
            self.masterBrands = []
            self.masterModels = []
            self.masterBrand = ""
            self.masterModel = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.masterBrands.push(res.brand)
                    // self.masterModels.push(res.model)
                }
                // self.masterBrands = _.uniqBy(self.masterBrands, 'brand');
            })
        },
        masterBrand(val) {
            let self = this
            self.masterModels = []
            self.masterModel = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.masterClassification) {
                    self.masterModels.push(res.model)
                }
            })
        }, 

        classification(val) {
            let self = this
            self.masterBrands = []
            self.masterModels = []
            self.make = ""
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.masterBrands.push(res.brand)
                    // self.masterModels.push(res.model)
                }
                // self.masterBrands = _.uniqBy(self.masterBrands, 'brand');
            })
        },
        make(val) {
            let self = this
            self.masterModels = []
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.classification) {
                    self.masterModels.push(res.model)
                }
            })
        }, 

        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))

        },
        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        selected: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        mcUnit: function(val) {
            let self = this
            let process = 0

            if(self.mcLists){
                let list = _.filter(self.mcLists, item => item.model === self.mcUnit)
                list.forEach(function(res) {
                    self.oldOdo = res.odometer
                    self.selectedMc = res
                })
            }
            self.odometer = ""
        },

        calendar: function(val) {
            let self = this
            let adminTime = []
            let adminTimeProcess = 0
            self.eventTimes = []
            self.schedtime = null
            self.times = []

            if (self.mechanics.length === 1) {
                self.mechanic = self.mechanics[0]
            } else {
                self.mechanic = ""
            }

            db.collection("Events"+self.$stage)
                .where("branchId","==",self.branchId)
                .where("status","==","approved")
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        adminTime.push(doc.data())
                        adminTimeProcess ++
                    })
                }).then(function() {
                    if(adminTimeProcess === adminTime.length) {
                        adminTime.forEach(function(res) {
                            if(res.date == self.calendar) {
                                self.eventTimes=res.timeHold
                            }
                        })
                        try {
                            console.log(self.eventTimes, val)
                            if( self.calendar != ""){
                                self.times = self.times.filter(value => !self.eventTimes.includes(value))
                            }
                        } catch(err) {}
                    }
                }).then(function(){
                    self.calendarValidation()
                    self.checkMechanics(self.mechanic)
                })
        },

        schedtime: function(val) {
            let self = this
            let index2 = []
            let lapsChecker = []
            self.timeRemoveHolder = []

            self.timeValidation2 = {
                appointmentTime: self.schedtime,
                blockTime: self.estimateTime / self.bufferTime
            }

            if(self.timeValidation2.appointmentTime != "" && self.timeValidation2.appointmentTime != null){      
                index2 = self.timesChecker.indexOf(self.timeValidation2.appointmentTime)
                self.timeRemoveHolder = self.timesChecker.splice(index2, self.timeValidation2.blockTime)
                self.laps = [].concat.apply([], self.laps)

                self.timeRemoveHolder.forEach(function(doc) {
                    if(self.laps.includes(doc)) {
                        lapsChecker.push(doc)
                    }
                })
                
                if(lapsChecker.length > 0) {
                    self.fetchTimeSchedule()
                    self.showAlert = true
                    self.alertColor = "red accent-4"
                    self.alertMessage="Cannot accomodate service in your selected hours. Please select another time"
                    setTimeout(() => {
                        index2 = []
                        lapsChecker = []
                        self.timeRemoveHolder = []
                        self.schedtime = null
                    }, 500)
                }
            }
        },
        
        mechanic: function(val) {
            this.checkMechanics(val)
        },

        Auth: {
           handler: function(newValue) {
                let self = this
                if (self.Auth.profileComponent == "1") {
                    self.updateInfoDialog = true
                } else if  (self.Auth.profileComponent == "0") {
                    self.updateInfoDialog = false
                }

                if (self.Auth.motorcycleComponent == true) {
                    self.newMcProfileDialog = true
                    self.fetchMotorcycleDetails()
                } else {
                    self.newMcProfileDialog = false
                    self.fetchMotorcycleDetails()
                }
           },
           deep: true
        },
    }
}

</script>

<style scoped>
.transparent {
    background-color: white!important;
    opacity: 1;
    border-color: transparent!important;
}

.background {
    background-image: url('../img/matt-boitor-1390290-unsplash.jpg');
    background-size: 100% 40%;
    background-repeat: no-repeat;
    background-position-x: center;

}
#inspire {
    background: none;
}
</style>
